module.exports = __webpack_public_path__ + "media/flags/rs-91b2e222.svg";